import { render, staticRenderFns } from "./playerInGameCard.vue?vue&type=template&id=5985c112&scoped=true&"
import script from "./playerInGameCard.vue?vue&type=script&lang=js&"
export * from "./playerInGameCard.vue?vue&type=script&lang=js&"
import style0 from "./playerInGameCard.vue?vue&type=style&index=0&id=5985c112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985c112",
  null
  
)

export default component.exports